import { render, staticRenderFns } from "./TrendChart.vue?vue&type=template&id=2e52c6af"
import script from "./TrendChart.vue?vue&type=script&lang=js"
export * from "./TrendChart.vue?vue&type=script&lang=js"
import style0 from "./TrendChart.vue?vue&type=style&index=0&id=2e52c6af&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e52c6af')) {
      api.createRecord('2e52c6af', component.options)
    } else {
      api.reload('2e52c6af', component.options)
    }
    module.hot.accept("./TrendChart.vue?vue&type=template&id=2e52c6af", function () {
      api.rerender('2e52c6af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vueComponents/dashboardContainer/src/panels/TrendChart.vue"
export default component.exports